import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { ShieldQuestion } from "lucide-react";

export function IdentityReviews() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/identity/link-reviews").then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  const act = (r, path, body) => api.post(`/identity/link-reviews/${r.review_id}/${path}`, body).then(() => { toast.success("Saved"); load(); })
    .catch((e) => toast.error(e.response?.data?.detail || "Failed"));
  if (!rows.length) return null;
  return (
    <div className="border border-amber-300 bg-amber-50 rounded-2xl p-4 space-y-3" data-testid="identity-reviews">
      <div className="flex items-center gap-2 font-semibold text-amber-800"><ShieldQuestion size={16} /> Possible existing CaterCTRL identity — confirmation needed</div>
      <p className="text-xs text-amber-800">CaterCTRL found more than one of your staff records that could belong to this connected account. Nothing has been merged. Confirm the right record only when you are sure, reject the match, or leave it for later.</p>
      {rows.map((r) => (
        <div key={r.review_id} className="bg-white rounded-xl border p-3 text-sm space-y-2" data-testid={`identity-review-${r.review_id}`}>
          <div>Account: <strong>{r.account.name}</strong> <span className="text-slate-500">{r.account.email}</span></div>
          {r.candidates.map((c) => (
            <div key={c.person_id} className="flex justify-between items-center border-t pt-2">
              <span>{c.display_name} <span className="text-xs text-slate-400">{c.department}</span></span>
              <Button size="sm" onClick={() => act(r, "confirm", { person_id: c.person_id })} data-testid={`identity-review-confirm-${c.person_id}`}>This is them</Button>
            </div>))}
          <div className="flex gap-2"><Button size="sm" variant="outline" onClick={() => act(r, "reject", {})} data-testid={`identity-review-reject-${r.review_id}`}>Not a match</Button>
            <span className="text-xs text-slate-400 self-center">or leave unresolved</span></div>
        </div>))}
    </div>
  );
}
